:host {
  font-family: var(--ai12z-bot-font-family) !important;
  font-size: var(--ai12z-bot-font-size) !important;
}
.history-list {
  margin: 0;
  padding: 0;
  list-style: none;
}
.conversation-list-item {
  background: var(--ai12z-bot-primary-color);
  border-bottom: 1px solid #dcdcdc;
  padding: 0;
  transition: background 0.4s ease;
  cursor: pointer;
}

.conversation-list-item-body {
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  display: flex;
  margin: 8px 16px;
}
.conversation-list-item-body-content {
  margin: 0 0 0 16px;
  position: relative;
  /* width: -webkit-calc(100% - 48px);
  width: -moz-calc(100% - 48px); */
  width: calc(100% - 48px);
}

.conversation-list-item-body-content h2 {
  font-size: 14px;
  margin: 0;
}
.conversation-list-item-time {
  color: var(--ai12z-bot-history-text-color);
  font-size: 12px;
  position: absolute;
  right: 0;
  top: 2px;
}
.conversation-list-item-last-message {
  margin: 0;
  padding: 0;
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  color: var(--ai12z-bot-history-text-color);
  font-size: 14px;
}
.avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-right: 10px;
}
